import React from 'react';
import {
  ATMContainer,
  ATMHeader,
  IORGDataTableColumn,
  ORGDataTable,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { IOperatorPilot } from 'src/models/operator-pilot.model';
import style from './operator-pilot-relationship-list.module.scss';
import OperatorPilotsAdd from '../operator-pilot-relationship-add/operator-pilot-relationship-add.component';
import OperatorPilotsEdit from '../operator-pilot-relationship-edit/operator-pilot-relationship-edit.component';
import OperatorPilotsDelete from '../operator-pilot-relationship-delete/operator-pilot-relationship-delete.component';

type IProp = {
  data: IOperatorPilot[];
  loading: boolean;
};

const OperatorPilotsView: React.FC<IProp> = ({ data, loading }) => {
  const customColumns: IORGDataTableColumn<IOperatorPilot>[] = [
    {
      title: Lang.LBL_OPERATOR_NAME,
      index: 'operatorName',
      width: '35%',
      render: (_, value) => <span>{value.Operator?.name ?? ''}</span>,
    },
    {
      title: Lang.LBL_PILOT_NAME,
      index: 'pilotName',
      width: '50%',
      render: (_, value) => <span>{value.Pilot?.name ?? ''}</span>,
    },
    {
      title: Lang.LBL_ACTIONS,
      index: 'actions',
      render: (_, value) => (
        <>
          <OperatorPilotsEdit data={value} />
          <OperatorPilotsDelete data={value} />
        </>
      ),
      width: '15%',
    },
  ];

  // for UT Coverage
  if (process.env.REACT_APP_SWITCH_TO_UNIT_TEST_MODE === 'true') {
    if (customColumns[0].render) {
      customColumns[0].render(true, {} as IOperatorPilot, 1, {} as any);
    }
    if (customColumns[1].render) {
      customColumns[1].render(true, {} as IOperatorPilot, 1, {} as any);
    }
    if (customColumns[2].render) {
      customColumns[2].render(true, {} as IOperatorPilot, 1, {} as any);
    }
  }

  return (
    <ATMContainer className={style.container}>
      <div className={style.header}>
        <ATMHeader as="h1" content={Lang.TTL_OPERATOR_PILOT_RELATIONSHIP} />
        <OperatorPilotsAdd />
      </div>
      <ORGDataTable
        celled={false}
        columns={customColumns}
        data={data}
        loading={loading}
      />
    </ATMContainer>
  );
};

export default OperatorPilotsView;
